<template>
    <div class="page">
        <img class="logo" src="@/assets/image15.png" @load="coverImgload" />
        <div class="cover">
            <img ref="imgRef" class="cover__img" src="@/assets/mobile/image1.png" @load="coverImgload" />
            <div class="title">
                <div class="title__text title__text-1">AMAZEEN</div>
                <div class="title__text title__text-2">SOLUTIONS</div>
                <div class="title__text title__text-3">LTD</div>
                <div class="title__text1 title__text-4 mt24">Amazeen Solutions Ltd is incorporated in United Arab Emirates and certified by the Government of Ras Al Khaimah (RAK) Digital Assets Oasis Authority. The company is licensed to conduct business nature involving Web3.0 services and act as service provider for Metaverse. </div>
            </div>
            <img class="guide__img" src="@/assets/image10.png" />
        </div>
        <div class="main">
            <div class="box1 p-l-23 p-r-17">
                <div class="box1__main">
                    <img class="box1__bg" src="@/assets/mobile/image2.png">
                    <div class="text1 mb22">
                        {{ textJSON.box1.title }}
                    </div>
                    <div class="text2 mb22">
                        {{ textJSON.box1.paragraph1 }}
                    </div>
                    <div class="text2">
                        {{ textJSON.box1.paragraph2 }}
                    </div>
                </div>
            </div>
            <div class="box2 p-l-23 p-r-17">
                <div class="text3 mb14">
                    {{ textJSON.box2.title }}
                </div>
                <div class="box2__item">
                    <img class="box2__item__img" src="@/assets/image14.png">
                    <div class="text4 p-l-7"> {{ textJSON.box2.paragraph1 }}</div>
                </div>
                <div class="box2__item">
                    <img class="box2__item__img" src="@/assets/image13.png">
                    <div class="text4 p-l-7"> {{ textJSON.box2.paragraph2 }}</div>
                </div>
                <div class="box2__item">
                    <img class="box2__item__img" src="@/assets/image12.png">
                    <div class="text4 p-l-7"> {{ textJSON.box2.paragraph3 }}</div>
                </div>
                <div class="box2__item">
                    <img class="box2__item__img" src="@/assets/image11.png">
                    <div class="text4 p-l-7"> {{ textJSON.box2.paragraph4 }}</div>
                </div>
            </div>
            <div class="box3 p-l-23 p-r-17">
                <div class="text1">
                    {{ textJSON.box3.title }}
                </div>
                <div class="text5 mb14">
                    {{ textJSON.box3.title2 }}
                </div>
                <div class="box3__car">
                    <ProjectCar ref="projectCarRef" type="mobile" class="project-car"></ProjectCar>
                </div>
                <div class="frc box3__project">
                    <div class="box3__project--markers"></div>
                    <div class="box3__project--text">
                        {{ textJSON.box3.title3 }}
                    </div>
                </div>
                <div class="text6">{{ textJSON.box3.paragraph4 }}</div>
                <div class="text6 mb14">{{ textJSON.box3.paragraph5 }}</div>
                <DownloadBtn type="mobile"></DownloadBtn>
            </div>
            <div class="box4">
                <!-- <img class="box4__img" src="@/assets/image16.png"> -->
                <div class="box4-section">
                    <div class="box4-box">
                        <img class="box4-section__img" src="@/assets/image18.png">
                    </div>
                    <div class="box4-box">
                        <img class="box4-section__img" src="@/assets/image18.png">
                    </div>
                </div>
            </div>
            <div class="box5 p-l-23 p-r-17">
                <img class="box5__img" src="@/assets/mobile/image.png">
                <div class="text1">
                    {{ textJSON.box5.title }}
                </div>
                <div class="text5 mb14">
                    {{ textJSON.box5.title1 }}
                </div>
                <div class="form">
                    <div class="form__input">
                        <div class="form__input__label">Name (compulsory)</div>
                        <input type="text" class="form__input__input" v-model="formData.name">
                    </div>
                    <div class="form__input">
                        <div class="form__input__label">Email (compulsory)</div>
                        <input type="text" class="form__input__input" v-model="formData.eamil">
                    </div>
                    <div class="form__input">
                        <div class="form__input__label">Contact</div>
                        <input type="text" class="form__input__input" v-model="formData.contact">
                    </div>
                    <div class="form__input">
                        <div class="form__input__label">Subject</div>
                        <input type="text" class="form__input__input" v-model="formData.subject">
                    </div>
                    <div class="form__input f1">
                        <div class="form__input__label">Message</div>
                        <textarea v-model="formData.message" class="form__input__input form__input__input--textarea f1" rows="10"></textarea>
                    </div>
                    <div class="form__submit">
                        <div class="form__submit__btn" @click="onContactUs">
                            Submit
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <!-- <Contact class="mb17"></Contact> -->
                <MailAddress class="mb17"></MailAddress>
                <Email class="mb17"></Email>
                <div class="text7">
                    {{ textJSON.footer.title }}
                </div>
                <div class="text7">
                    {{ textJSON.footer.title1 }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, reactive } from 'vue';
import gsap from 'gsap-trial';
import ProjectCar from '@/components/ProjectCar.vue'
import DownloadBtn from '@/components/DownloadBtn.vue'
import Contact from '@/components/Contact.vue'
import MailAddress from '@/components/MailAddress.vue'
import Email from '@/components/Email.vue'
import textJSON from '@/assets/json/text.json'
import { ScrollTrigger } from 'gsap-trial/ScrollTrigger';
import Request from '@/core/request'
import { ElMessage } from 'element-plus'

gsap.registerPlugin(ScrollTrigger);
const main = ref();
const scrollContainer = ref(null)
const projectCarRef = ref(null)
const clientHeight = ref(0)
const scrollTop = ref(0)
const scrollHeight = ref(0)
const imgRef = ref()
const imgClientHeight = ref(0)
const topRef = ref()
const loading = ref(false)
const formData = reactive({
    email: '',
    name: '',
    subject: '',
    contact: '',
    message: ''
})
const errorMessage = reactive({
    name: 'Please enter name',
    email: 'Please enter email',
    contact: 'Please enter contact',
    subject: '',
    message: ''
})
let ctx;
const coverImgload = (e) => {
    imgClientHeight.value = imgRef.value.clientHeight
}

const onContactUs = () => {
    if (loading.value) return
    for (const key in formData) {
        if (!formData[key] && errorMessage[key]) {
            ElMessage({
                message: errorMessage[key],
                type: 'warning',
            })
            return
        }
    }
    loading.value = true
    Request.get(`/api/system/contactUs?email=${formData.email}&name=${formData.name}&subject=${formData.subject}&contact=${formData.contact}&message=${formData.message}`).then(res => {
        console.log(res)
        const { data } = res || {}
        console.log(data)
        if (data.code === 0) {
            ElMessage({
                message: 'Submit successfully',
                type: 'success',
            })
        }
    }).finally(() => {
        loading.value = false
    })
}

onMounted(() => {
    window.addEventListener('scroll', (e) => {
        clientHeight.value = document.documentElement.clientHeight
        scrollHeight.value = document.documentElement.scrollHeight
        scrollTop.value = document.documentElement.scrollTop
        if (clientHeight.value + scrollTop.value >= scrollHeight.value - clientHeight.value) {
            console.log('到底了')
        } else {
            gsap.to('.cover', {
                opacity: 1 - (scrollTop.value / imgClientHeight.value),
                y: scrollTop.value / 2
            })
        }
        
    })
    ctx = gsap.context(() => {
        gsap.from('.logo', {
            scrollTrigger: '.logo',
            duration: 2,
            opacity: 0,
            rotationY: 180,
            transformOrigin: "50% 50% 50%",
        })
        gsap.from('.title', {
            scrollTrigger: '.title',
            y: 200,
            opacity: 0
        })
        gsap.from('.box1', {
            scrollTrigger: '.box1',
            xPercent: -100
        })
        gsap.from('.box2', {
            scrollTrigger: '.box2',
            scale: 0
        })
        gsap.from('.project-car', {
            scrollTrigger: '.project-car',
            duration: 1,
            rotationY: 180,
            transformOrigin: "50% 50% 50%",
            onComplete: () => {
                console.log(projectCarRef.value)
                // projectCarRef.value.countUpStart()
            }
        })
        gsap.to('.box4-box', {
            scrollTrigger: '.box4-box',
            xPercent: -100,
            duration: 60,
            ease: 'none',
            repeat: -1
        })
    }, main.value);
});
onUnmounted(() => {
    ctx.revert();
});
</script>

<style scoped>
.page{
    position: relative;
    font-size: 0;
}
.frc{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.p-l-23{
    padding-left: 23px;
}
.p-r-17{
    padding-right: 17px;
}
.p-l-7{
    padding-left: 7px;
}
.main{
    background-color: #fff;
    position: relative;
}
.mb14{
    margin-bottom: 14px;
}
.mb17{
    margin-bottom: 17px;
}
.mb22{
    margin-bottom: 22px;
}
.mt24{
    margin-top: 24px;
}

.text1{
    font-weight: 600;
    font-size: 34px;
    color: #F16323;
    line-height: 33px;
}
.text2{
    font-weight: 400;
    font-size: 14px;
    color: #343434;
    line-height: 18px;
}
.text3{
    font-weight: 600;
    font-size: 18px;
    color: #343434;
    line-height: 20px;
}
.text4{
    font-weight: 400;
    font-size: 14px;
    color: #343434;
    line-height: 15px;
}
.text5{
    font-weight: bold;
    font-size: 16px;
    color: #B3B3B3;
    line-height: 33px;
}
.text6{
    font-weight: 400;
    font-size: 14px;
    color: #343434;
    line-height: 18px;
}
.text7{
    font-weight: 500;
    font-size: 12px;
    color: #838383;
    line-height: 16px;
}
.cover{
    position: relative;
    min-height: 100vh;
}
.cover__img{
    width: 100vw;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 50%;
    inset-inline-start: 50%;
    transform: translate(-50%, -50%);
}
.logo{
    z-index: 1;
    position: absolute;
    top: 7.7vw;
    left: 6.1vw;
    width: 34.6vw;
}
.title{
    width: 87.7vw;
    position: absolute;
    top: 50%;
    left: 3.5%;
    transform: translateY(-50%);
}
.title__text {
    font-weight: bold;
    font-size: 52px;
    color: #FFFFFF;
    line-height: 41px;
    text-align: left;
}
.title__text1{
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 17px;
}
.guide__img{
    width: 19.5vw;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}
.box1{
    padding-top: 37px;
    padding-bottom: 17px;
}
.box1__main{
    position: relative;
}
.box1__bg{
    width: 69.8vw;
    position: absolute;
    right: 0;
    top: 0;
}
.box2{
    margin-top: 12px;
}
.box2__item{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.box2__item__img{
    width: 21.33vw;
}
.box3{
    margin-top: 37px;
}
.box3__car{
    width: 90.6vw;
}
.box3__project{
    margin-top: 26px;
    margin-bottom: 12px;
}
.box3__project--markers{
    width: 21px;
    height: 21px;
    background-color: #F16323;
    transform: rotate(45deg);
}
.box3__project--text{
    font-weight: bold;
    font-size: 21px;
    color: #343434;
    line-height: 25px;
    margin-left: 10px;
}

.box4{
    position: relative;
    padding: 26px 0;
    width: 100vw;
    overflow: hidden;
}
.box4-box{
    box-sizing: border-box;
    width: 200vw;
    padding: 0 0.6vw;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
}
.box4-section{
    width: 400vw;
    display: flex;
    flex-direction: row;
}
.box4::before{
    z-index: 2;
    display: block;
    content: "";
    position: absolute;
    top: 26px;
    bottom: 26px;
    left: 0;
    width: 29vw;
    background: linear-gradient(270deg, rgba(255,255,255,0) 0%, #FFFFFF 80%, #FFFFFF 100%);
}
.box4::after{
    z-index: 2;
    display: block;
    content: "";
    position: absolute;
    top: 26px;
    bottom: 26px;
    right: 0;
    width: 29vw;
    background: linear-gradient(-270deg, rgba(255,255,255,0) 0%, #FFFFFF 80%, #FFFFFF 100%);
}
.box4-section__img{
    width: 198.8vw;
}
.box5{
    position: relative;
    padding-top: 33px;
    padding-bottom: 27px;
}
.box5 div{
    position: relative;
}
.box5__img{
    width: 100vw;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
}
.form__input{
    margin-bottom: 12px;
}
.form__input__label{
    font-weight: 400;
    font-size: 14px;
    color: #343434;
    line-height: 20px;
    margin-bottom: 5px;
}
.form__input__input{
    width: 100%;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #C8C8C8;
    font-size: 18px;
    padding: 0 8px;
}
.form__input__input--textarea{
    height: 100px;
    resize: none;
    padding: 8px;
}
.form__submit{
    padding-top: 16px;
    display: flex;
    justify-content: center;
}
.form__submit__btn{
    width: 68.2vw;
    height: 50px;
    background-color: #F16323;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 20px;
}
.footer{
    padding: 24px 32px;
    background-color: #2A2A2A;
    position: relative;
}
</style>